export default class ContactPreferences {

	constructor(name) {
		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			toastDisplay: true,
			toastMessage: 'Bezig met laden...',
			successMessage: null,
			showSaveBtn: false,
			errorMessage: null,
			SubPlanId: null,
			maxObjectPreferences: null,
			residentialObjects: [],
			items: [],
			AddItem(){
				if(this.items.length && this.items.length >= this.maxObjectPreferences) return false;
				if(this.items.length && this.items[this.items.length - 1].object_id == '') return false;
				this.items.push({ object_id: '', index: this.items.length + 1})
				this.successMessage = null
			},
			Voorkeur(index){
				var Voorkeuren = [];

				for (var i = 1; i <= this.maxObjectPreferences; i++) {
					Voorkeuren.push(i + 'ᵉ voorkeur' );
				}

				return Voorkeuren[index]
			},
			Init(SubPlanId){
				var vm = this;
				vm.SubPlanId = SubPlanId
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						var responce = JSON.parse(this.responseText)

						var tmp_items = JSON.parse( responce.contactPreferences )
						if( tmp_items.length >= 1){
							vm.items =  tmp_items
						}else{
							vm.AddItem();
						}
						vm.residentialObjects = responce.residentialObjects
						vm.maxObjectPreferences = responce.maxObjectPreferences
						vm.toastDisplay = false
						vm.loading = false
						vm.messages = JSON.parse(this.responseText).messages;
					}
				}
				xhttp.open('post', '/woonmens/api/get-contact-preferences/', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');

				setTimeout(function() {
					xhttp.send(JSON.stringify( {'sub_plan_id': SubPlanId} ) );
				}, 1000)
			},

			Submit(SubPlanId) {
				var vm = this
				vm.loading = true
				var xhttp = new XMLHttpRequest();
				xhttp.open('post', '/woonmens/api/update-contact-preferences', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.onreadystatechange = function() {

					if( vm.items.length == 0){
						vm.AddItem();
					}

					if (this.readyState == 4 && this.status == 200) {
						window.dataLayer.push({
							'event': 'objectvoorkeuren',
							...vm.pushPreferencesDataLayer()
						});

						setTimeout(function() {
							vm.loading = false
							vm.toastDisplay = true
							vm.toastMessage = 'Opgeslagen'
							vm.successMessage = 'Uw voorkeuren zijn succesvol opgeslagen'
							vm.showSaveBtn = false;
						}, 100)

						setTimeout(function() {
							vm.toastDisplay = false
							vm.successMessage = null
						}, 2000)
					}
				}
				// Remove empty items
				vm.items = vm.items.filter(function (el, index) {
					el.index = index + 1
					return el.object_id != '';
				});
				xhttp.send(JSON.stringify( {'sub_plan_id': SubPlanId , 'preferences': vm.items} ) );
			},
			pushPreferencesDataLayer() {
                let preferences = [];

                for (const item of this.items) {
					preferences[item.object_id] = item.object_name;
                }
                return preferences;
            },
			Swap(Direction, ArrayIndex){
				this.successMessage = null
				this.showSaveBtn = true
				if ('up' == Direction) {
					this.SwitchPlaces(ArrayIndex, ArrayIndex - 1);
				} else {
					this.SwitchPlaces(ArrayIndex, ArrayIndex + 1);
				}
			},

			SwitchPlaces(a, b)
			{
				const input = this.Clone(this.items)
				const output  = this.Clone(this.items);
				if (typeof input[b] === 'undefined') {
					return;
				}

				output[a].object_name = input[b].object_name
				output[a].object_id = input[b].object_id

				output[b].object_name = input[a].object_name
				output[b].object_id = input[a].object_id

				this.items = output;
				// this.Submit(this.SubPlanId)
			},

			Clone(obj) {
				if(obj == null || typeof(obj) != 'object')
					return obj;
				var temp = new obj.constructor();
				for(var key in obj)
					temp[key] = this.Clone(obj[key]);
				return temp;
			},

			RemoveItem(Index){
				delete this.items[Index];
				this.items = this.items.filter(function (el, index) {
					el.index = index + 1
					return el.object_id != '';
				});
				// this.Submit(this.SubPlanId)
				this.successMessage = null
				this.showSaveBtn = true
			},
			CanAddItems(){
				var vm = this
				if( vm.items.length == 0 ) return false
					if(vm.items.length >= vm.maxObjectPreferences) return false
						if(vm.items[vm.items.length - 1].object_id == '') return false

							return true;
					},

					IsSelected(UniqueId){
						for (var element of this.items)
							if(element['object_id'] == UniqueId)
								return false;

							return true
						},


					}
				}
			}
